import { render, staticRenderFns } from "./MBUpload.vue?vue&type=template&id=2f2110b6&"
import script from "./MBUpload.vue?vue&type=script&lang=js&"
export * from "./MBUpload.vue?vue&type=script&lang=js&"
import style0 from "./MBUpload.vue?vue&type=style&index=0&id=2f2110b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports